var roomNames = {}
var roomCodes = {}
var roomDisplayNames = {}

function addRoomType (name, code, displayName) {
  roomNames[code] = name
  roomCodes[name] = code
  roomDisplayNames[name] = displayName
}

addRoomType('single', 'SIG', 'single')
addRoomType('twin', 'TWN', 'twin')
addRoomType('twinShare', 'TWS', 'twin share')
addRoomType('triple', 'TRP', 'triple')
addRoomType('tripleShare', 'TRS', 'triple share')
addRoomType('quad', 'QAD', 'quad')
addRoomType('quadShare', 'QDS', 'quad share')
addRoomType('multiShare', 'MTS', 'multi share')

function getRoomTypeValueIfFound (value) {
  return typeof value === 'string' ? value : null
}

const roomTypes = {
  codeForTypeName: function (typeName) {
    return getRoomTypeValueIfFound(roomCodes[typeName])
  },

  typeNameForCode: function (code) {
    return getRoomTypeValueIfFound(roomNames[code])
  },

  displayNameForName: function (name) {
    return getRoomTypeValueIfFound(roomDisplayNames[name])
  },

  displayNameForCode: function (code) {
    return getRoomTypeValueIfFound(roomDisplayNames[this.typeNameForCode(code)])
  },

  types: function () {
    return Object.keys(roomCodes)
  },

  isShare (roomType) {
    return roomType.match(/Share/)
  },
}

export default roomTypes
